import Vue from 'vue';
import orderTransformer from './../../transformers/order';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentOrder', orderTransformer.fetch(data));
  resolve(data);
};

const failed = (error, reject) => reject(error);

export default (id, order) => (
  new Promise((resolve, reject) => {
    const url = `/orders/confirm-shipping/${id}`;

    Vue.$http
      .post(url, order)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/confirmShipping.js